'use strict';

export function initPageHeader() {
  const header = document.getElementById('page-header');

  if (!header) {
    return;
  }

  // Function to update header position based on Drupal displacement
  function updateHeaderPosition() {
    const rootStyles = getComputedStyle(document.documentElement);
    const topOffset = rootStyles.getPropertyValue('--drupal-displace-offset-top').trim();
    const leftOffset = rootStyles.getPropertyValue('--drupal-displace-offset-left').trim();

    console.log([rootStyles, topOffset, leftOffset]);

    // Apply the offsets to the header
    if (topOffset) {
      header.style.top = topOffset;
    }
    if (leftOffset) {
      header.style.left = leftOffset;
    }
  }

  // Initial update
  updateHeaderPosition();

  // Listen for Drupal displacement changes
  document.addEventListener('drupalViewportOffsetChange', updateHeaderPosition);

  // Optional: Use MutationObserver to watch for CSS variable changes
  const observer = new MutationObserver(updateHeaderPosition);
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['style']
  });

  // Handle scroll state
  const handleScroll = () => {
    if (window.scrollY > 0) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  };

  window.addEventListener('scroll', handleScroll);
}